import { cn } from "@/lib/utils";

export const StatusBadge = ({ config, code, size = "sm", testId, className }) => {
  const c = config[code] || { label: code || "—", badge: "bg-slate-500/15 text-slate-300 border-slate-600/40" };
  return (
    <span data-testid={testId}
      className={cn("inline-flex items-center gap-1.5 border rounded-sm font-mono uppercase tracking-tight whitespace-nowrap",
        size === "sm" ? "text-[10px] px-1.5 py-0.5" : "text-xs px-2 py-1", c.badge, className)}>
      {c.dot && <span className={cn("h-1.5 w-1.5 rounded-full", c.dot, c.pulse && "animate-pulse")} />}
      {c.label}
    </span>
  );
};
